// Autogenerated file
export const bidChatFlagsEnum = {
    None: "None",
    HasUploadedFile: "HasUploadedFile",
};
export const bidChatFlags = [
    { label: "Без опций", value: "None", intValue: 0 },
    { label: "В заявку загружен файл(ы)", value: "HasUploadedFile", intValue: 1 },
];
